import { DEFAULT_CURRENCY, FILE_TYPE_CSV } from '@constants/global';
import { Customers } from '@domain/customer';
import { formatDate } from '@utils/format-date/format-date';
import { formatNumber, formatValue } from '@utils/format-number/format-number';
import { fromBackendToDate } from '@utils/map-date/from-backend';

import { CustomerTable } from '../customer.types';

export const customerData: Customers = [
  {
    fullName: 'Ferran Rovira',
    email: 'ferran@xceed.me',
    phone: '+34676676676',
    language: 'es',
    marketingConditionsAccepted: true,
    expense: {
      total: 2515,
      average: 30.56,
      currency: DEFAULT_CURRENCY,
    },
    bookings: {
      total: 2,
      tickets: 4,
    },
    lastBooking: {
      date: 1708351468,
    },
  },
  {
    fullName: 'Bernat de Pablo',
    email: 'bernat@xceed.me',
    phone: '+34666666666',
    language: 'es',
    marketingConditionsAccepted: true,
    expense: {
      total: 2002,
      average: 10.56,
      currency: DEFAULT_CURRENCY,
    },
    bookings: {
      total: 3,
      tickets: 6,
    },
    lastBooking: {
      date: 1708351468,
    },
  },
];
export const exportTypes = [
  // {
  //   id: FILE_TYPE_EXCEL,
  //   name: 'Excel (.xlsx)',
  // },
  {
    id: FILE_TYPE_CSV,
    name: 'Comma Separated Values UTF-8 (.csv)',
  },
];
export const mapCustomersToTable = (customers: Customers, locale: string): CustomerTable[] => {
  return customers.map((customer) => {
    const { fullName, email, phone, language, marketingConditionsAccepted, expense, bookings, lastBooking } = customer;
    return {
      fullName,
      email,
      phone,
      language,
      averageExpense: formatNumber({
        number: expense.average,
        locale,
        currency: customer.expense.currency,
      }),
      totalExpense: formatNumber({
        number: expense.total,
        locale,
        currency: customer.expense.currency,
      }),
      totalBookings: formatValue({ number: bookings.total, locale }),
      totalTickets: formatValue({ number: bookings.tickets, locale }),
      marketingConditionsAccepted,
      lastBookingDate: formatDate({
        date: fromBackendToDate(lastBooking.date as number),
        options: {
          dateStyle: 'medium',
        },
        locale,
      }),
    };
  });
};

export const mapCustomersTableHeader = (customers: CustomerTable[]) => {
  const {
    fullName,
    email,
    phone,
    language,
    averageExpense,
    totalExpense,
    totalTickets,
    marketingConditionsAccepted,
    totalBookings,
    lastBookingDate,
  } = customers[0];
  return [
    {
      label: 'fullName',
      id: 'fullName',
      value: fullName,
    },
    {
      label: 'email',
      id: 'email',
      value: email,
    },
    {
      label: 'phone',
      id: 'phone',
      value: phone,
    },
    {
      label: 'language',
      id: 'language',
      value: language,
    },
    {
      label: 'averageExpense',
      id: 'averageExpense',
      value: averageExpense,
    },
    {
      label: 'totalExpense',
      id: 'totalExpense',
      value: totalExpense,
    },
    {
      label: 'totalBookings',
      id: 'totalBookings',
      value: totalBookings,
    },
    {
      label: 'totalTickets',
      id: 'totalTickets',
      value: totalTickets,
    },
    {
      label: 'marketingConditionsAccepted',
      id: 'marketingConditionsAccepted',
      value: marketingConditionsAccepted,
    },
    {
      label: 'lastBookingDate',
      id: 'lastBookingDate',
      value: lastBookingDate,
    },
  ];
};

export const downloadFile = (data: Blob, exportType: string, filename: string) => {
  const blob = new Blob([data], { type: data.type ?? `text/${exportType}` });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  const fileName = filename.includes('.') ? filename : `${filename}.${exportType}`;
  a.setAttribute('href', url);
  a.setAttribute('download', fileName);
  a.click();
};
export const NUMBER_FIELDS = ['totalExpense', 'averageExpense', 'totalTickets', 'totalBookings', 'lastBookingDate'];
export const CLICKABLE_FIELDS = [
  'totalExpense',
  'averageExpense',
  'totalTickets',
  'totalBookings',
  'fullName',
  'lastBookingDate',
  'email',
];
